import IntegrationIcon from "./IntegrationIcon";

import { Link } from "react-router-dom";

const CardSourceInfo = ({ feedEntry, toggleContent }: any) => {
  return (
    <div className="not-format md:order-first">
      <div className="flex items-center not-italic mb-4 px-4 inline-flex items-center mr-3 text-gray-900 dark:text-white">
        <span className="shrink-0">
          <IntegrationIcon video={feedEntry} />
        </span>
        <span>
        <Link to={`/entries/${feedEntry.integration_slug}/${feedEntry.integration_object_id}`}>
          <div
            className="text-sm font-bold text-gray-900 dark:text-white"
            style={{
              fontFamily: "Montserrat",
            }}
          >
            {feedEntry.title}
          </div>
          <div
            className="text-gray-900 dark:text-orange-100 font-thin"
            style={{
              fontFamily: "Montserrat",
            }}
          >
            {feedEntry.creator_name}
          </div>
        </Link>
        </span>
      </div>
    </div>
  );
};

export default CardSourceInfo;
